import styles from '../config/styles.json'
import { defaultTheme } from 'react-admin'

import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  ...defaultTheme,
  typography: {
    color: styles.body.color,
    fontSize: styles.body.fontSize,
    fontFamily: styles.body.fontFamily,
    h1: {
      color: styles.headings_color,
      fontSize: '4.25em',
      fontWeight: 500,
    },
    h2: {
      color: styles.headings_color,
      fontSize: '2.625em',
      fontWeight: 500,
    },
    h3: {
      color: styles.headings_color,
      fontSize: '1.9792em',
      fontWeight: 500,
    },
    h4: {
      color: styles.headings_color,
      fontSize: '1.625em',
      fontWeight: 500,
    },
    h5: {
      color: styles.headings_color,
      fontSize: '1.4792em',
      fontWeight: 500,
    },
    h6: {
      color: styles.headings_color,
      fontSize: '1.3333em',
      fontWeight: 500,
    },
    body1: {},
  },
  palette: {
    primary: {
      main: styles.colors.primary,
    },
    secondary: {
      main: styles.colors.secondary,
    },
  },
  spacing: 4,
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: styles.colors.primary,
          color: 'white',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        subtitle1: {
          fontWeight: '600',
        },
        subtitle2: {
          fontWeight: '600',
        },
        h1: {
          color: styles.colors.primary,
        },
      },
    },
    MuiCardHeader: {
      //backgroundColor: indigo[50]
      styleOverrides: {
        root: { backgroundColor: styles.card.card_header_bgColor },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          marginBottom: 16,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          whiteSpace: 'nowrap',
          paddingRight: 32,
          paddingLeft: 32,
          textTransform: 'none',
          fontWeight: 400,
        },
        labelIcon: {
          minHeight: 'inherit',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minWidth: 'inherit',
          textTransform: 'none',
          fontWeight: 400,
        },
        textSizeSmall: {
          fontSize: '.8em',
        },
        containedSecondary: {
          color: 'white',
        },
      },
    },
    /* MuiCard: {
			styleOverrides: {
				root: {
					position: 'relative',
					paddingBottom: 46,
				},
			}
		}, */
    /* MuiCardActions: {
			styleOverrides: {
				root: {
					position: 'absolute',
					bottom: 0,
				},
			}
		}, */
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: styles.container_maxwidth,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        sizeSmall: {
          padding: '6px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          color: styles.body.color,
        },
      },
    },
    MuiCssBaseline: {
      /* "@global": {
				'body': {
					backgroundColor: 'red',
				},
			}, */
      /* styleOverrides: `
				body {
				color: grey;
				}
			`, */
      styleOverrides: {
        body: {
          backgroundColor: 'red',
        },
      },
    },
  },
})
